<nav class="saml-container-header d-flex" xmlns="http://www.w3.org/1999/html">
  <img
    alt="soregies_logo"
    class="img-logo"
    src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Logos+Groupe+Soregies/Logo+Groupe+Soregies/Logo+Groupe+Soregies.png"
  />
</nav>
<div class="saml-container">
  @if(errorMessage){
    <h1 class="title">{{ errorMessage }}</h1>
  }@else{
    <h1 class="title">Chargement en cours...</h1>
  }
</div>
